import { render } from "./AddPoints.vue?vue&type=template&id=66d0501d&scoped=true"
import script from "./AddPoints.vue?vue&type=script&lang=js"
export * from "./AddPoints.vue?vue&type=script&lang=js"

import "./AddPoints.vue?vue&type=style&index=0&id=66d0501d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d0501d"]])

export default __exports__